module.exports = __webpack_public_path__ + "static/media/logo168.eef620fa.png";